import { QueryClient } from '@tanstack/react-query';

import AppError from './app-error';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof AppError) {
          if (
            error.isNotFound ||
            error.isUnauthorized ||
            error.isForbidden ||
            error.isBadRequest ||
            error.isUnprocessableEntity
          ) {
            return false;
          }
        }

        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
      retryOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      staleTime: 1000 * 60 * 15,
      throwOnError: false,
    },
  },
});
